module.exports = __webpack_public_path__ + "static/media/sessionsLogo.d32ff36d.png";